module.exports = __webpack_public_path__ + "assets/img/cross.svg";